import Backbone from 'backbone';
import moment from 'moment';

export default Backbone.Model.extend({
    urlRoot: function() {
        return '/worker/user/banner';
    },

    isAvailable: function() {
        const data = this.get('survey');

        if (!data || !data.period) {
            return false;
        }

        const format = 'YYYY-MM-DD';

        const start = moment(data.period.start).format(format);
        const end = moment(data.period.end).format(format);
        const now = moment(new Date()).format(format);

        return now >= start && now <= end;
    },

    getSurveyData: function() {
        return this.get('survey');
    }
});
